import React from 'react'

export const FormSubHeading: React.FC<{heading: string}> = ({heading}) => {
  return (
    <p className="font-semibold text-[18px] leading-[24px] text-[#9566A0]">
      {heading}
    </p>
  )
}
